import { searchApiURL, apiURLv1, apiURLv2 } from '../config';

export const endpoints = {
  favoriteBoard: `${apiURLv2}/favorite/mine`,
  favoriteBoardItems: `${apiURLv2}/favorite/mine/items`,
  materialByKey: `${searchApiURL}/bykey`,
  createProject: `${apiURLv2}/projects`,
  getProjectTypes: `${apiURLv1}/sdg-api/projects/type/list`,
  addToCart: 'sdg_cart/lineitem/addmultiple',
  productsInventory: '/catalog/product/inventory',
  eventsGetAll: 'events/event/getall',
  eventGetAll: 'event/getall',
  eventGetEvent: 'event/get/event/',
};
